function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4D4D4D",
  fillRule: "evenodd",
  d: "M25.993 24.667c.697 0 1.27.524 1.334 1.204l.006.129c0 .736-.594 1.333-1.34 1.333H2.007a1.334 1.334 0 1 1 0-2.666h23.986zm-1.508-23.04l1.89 1.89a2.665 2.665 0 0 1-.005 3.772L13.173 20.486 8.209 21.73c-1.429.359-2.296-.514-1.938-1.939l1.245-4.963L20.713 1.632a2.67 2.67 0 0 1 3.772-.004zM10.817 15.302l-.893.892-.626 2.51 2.5-.613.904-.904-1.885-1.885zm8.954-8.96c.002.003-4.156 4.162-7.069 7.075l1.885 1.884 7.07-7.069c.002-.003-1.886-1.89-1.886-1.89z"
});

var SvgEditBenefit = function SvgEditBenefit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEditBenefit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-benefit.fa8c7892.svg";
export { ForwardRef as ReactComponent };